<section class="container-fluid sts-section sts-form" tabindex="0">
  <app-sts-section-header key="sts-need-help-header" [errors]="errors">Need Help?</app-sts-section-header>

  <app-sts-section-body key="sts-need-help-body">
    <!-- content is served by CMS -->
  </app-sts-section-body>

  <app-sts-lower-bar>
    <button class="sts-btn" app-sts-cms-txt
            key="sts-reset-by-email-text"
            key="sts-go-back"
            type="button"
            routerLink="/" >Go back
    </button>
  </app-sts-lower-bar>

</section>
